import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { API_POST_EMPLOYEE, KEY_POST_EMPLOYEE } from '../constants';
import { MOCK_RESPONSE_POST_EMPLOYEE } from '../mocks';

type RequestPostEmployee = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_PATH_KEY
>['request']['body'];

type ResponsePostEmployee = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_PATH_KEY
>['response']['body'];

export type CallParamsPostEmployee = RequestPostEmployee & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePostEmployee = ResponsePostEmployee;

type CallErrorPostEmployee = GenericApiError;

type CallSelectorsPostEmployee = {
  employee?: CallResponsePostEmployee;
};

export const postEmployeeCall = createGeneralCall<
  CallParamsPostEmployee,
  CallResponsePostEmployee,
  CallErrorPostEmployee,
  CallSelectorsPostEmployee
>({
  id: KEY_POST_EMPLOYEE,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_POST_EMPLOYEE(org as unknown as string);
  },
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  method: 'post',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_EMPLOYEE : undefined,
  selectors: {
    employee: ({ selectors }) =>
      createSelector(selectors.response, res => (res as CallResponsePostEmployee) || undefined),
  },
});
